<template>
    <div :style="style" ref="lavContainer"></div>
</template>

<script>
import lottie from 'lottie-web'

export default {
  props: {
    options: {
      type: Object,
      required: true
    },
    height: Number,
    width: Number
  },
  data () {
    return {
      style: {
        overflow: 'hidden',
        display: 'inline-block'
      }
    }
  },
  mounted () {
    let animationData

    if (this.options.animationData.default) {
      animationData = this.options.animationData.default
    } else {
      animationData = this.options.animationData
    }

    this.anim = lottie.loadAnimation({
      container: this.$refs.lavContainer,
      renderer: 'svg',
      loop: this.options.loop !== false,
      autoplay: this.options.autoplay !== false,
      animationData,
      rendererSettings: this.options.rendererSettings
    })
    this.$emit('animCreated', this.anim)
  }
}
</script>
